var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPartnerSkeletonImage = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 44,
    viewBox: "0 0 61 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 59,
    height: 42,
    rx: 3,
    fill: "white",
    stroke: "#F4F5FA",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2563_33641",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 44
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 44,
    rx: 4,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2563_33641)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 9,
    width: 32,
    height: 26,
    rx: 4,
    fill: "#F4F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8095 18.0462C26.8095 18.795 26.5085 19.5132 25.9727 20.0427C25.4368 20.5722 24.7101 20.8697 23.9524 20.8697C23.1946 20.8697 22.4679 20.5722 21.9321 20.0427C21.3962 19.5132 21.0952 18.795 21.0952 18.0462C21.0952 17.2973 21.3962 16.5792 21.9321 16.0496C22.4679 15.5201 23.1946 15.2227 23.9524 15.2227C24.7101 15.2227 25.4368 15.5201 25.9727 16.0496C26.5085 16.5792 26.8095 17.2973 26.8095 18.0462Z",
    fill: "#C7CCDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 9.19922C17.9391 9.19922 16.9217 9.58452 16.1716 10.2704C15.4214 10.9562 15 11.8864 15 12.8564V31.1421C15 32.112 15.4214 33.0422 16.1716 33.7281C16.9217 34.4139 17.9391 34.7992 19 34.7992H43C44.0609 34.7992 45.0783 34.4139 45.8284 33.7281C46.5786 33.0422 47 32.112 47 31.1421V12.8564C47 11.8864 46.5786 10.9562 45.8284 10.2704C45.0783 9.58452 44.0609 9.19922 43 9.19922H19ZM43 11.0278C43.5304 11.0278 44.0391 11.2204 44.4142 11.5634C44.7893 11.9063 45 12.3714 45 12.8564V24.7421L37.446 21.1818C37.2584 21.0959 37.0461 21.0661 36.839 21.0967C36.6319 21.1272 36.4405 21.2165 36.292 21.3519L28.872 28.1359L23.552 24.8957C23.3599 24.7788 23.1295 24.7262 22.8999 24.7468C22.6702 24.7675 22.4555 24.8601 22.292 25.009L17 29.3135V12.8564C17 12.3714 17.2107 11.9063 17.5858 11.5634C17.9609 11.2204 18.4696 11.0278 19 11.0278H43Z",
    fill: "#C7CCDD"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPartnerSkeletonImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/partner-skeleton-image.d7bf870d94c5a4d3e0a9c91347408468.svg";